var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewRecordedSuccessfully(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1668 18.4671V20.0004C37.1648 23.5945 36.001 27.0916 33.8491 29.9701C31.6971 32.8487 28.6723 34.9546 25.2258 35.9736C21.7792 36.9926 18.0956 36.8703 14.7243 35.6247C11.353 34.3792 8.47459 32.0773 6.51843 29.0622C4.56227 26.0472 3.63315 22.4805 3.86962 18.8943C4.1061 15.308 5.49551 11.8943 7.83063 9.16221C10.1658 6.43012 13.3215 4.52606 16.8271 3.734C20.3328 2.94194 24.0006 3.30432 27.2835 4.76709",
    stroke: "#34A853",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 6.66699L20.5 23.3503L15.5 18.3503",
    stroke: "#34A853",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewRecordedSuccessfully);
export default __webpack_public_path__ + "static/media/previewRecordedSuccessfully.8506e9aafd627d6f79704d4e56ae591e.svg";
export { ForwardRef as ReactComponent };